export default __webpack_public_path__ + "static/media/heirs-fire-damages.f02a4290.png";